import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  'download-tutorial': 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20app%20download%20progress%20with%20Chinese%20interface%2C%20warm%20red%20and%20gold%20color%20scheme%2C%20clean%20minimal%20background%2C%20professional%20tech%20photography&width=600&height=400&seq=cat-download&orientation=landscape',
  'login-register': 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20login%20and%20registration%20form%20in%20Chinese%2C%20warm%20friendly%20interface%20design%2C%20red%20and%20gold%20accents%2C%20clean%20minimal%20background&width=600&height=400&seq=cat-login&orientation=landscape',
  'user-guide': 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20app%20interface%20showing%20various%20features%20and%20navigation%2C%20warm%20red%20and%20gold%20color%20scheme%2C%20clean%20modern%20design&width=600&height=400&seq=cat-guide&orientation=landscape',
  'faq': 'https://readdy.ai/api/search-image?query=Help%20and%20support%20concept%20with%20Chinese%20question%20mark%20icons%2C%20warm%20friendly%20color%20scheme%2C%20red%20and%20gold%20accents%2C%20clean%20minimal%20design&width=600&height=400&seq=cat-faq&orientation=landscape',
  'latest-news': 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20and%20updates%20concept%20with%20announcement%20design%2C%20warm%20red%20and%20gold%20color%20scheme%2C%20clean%20professional%20layout&width=600&height=400&seq=cat-news&orientation=landscape',
};

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            教程分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            按需浏览不同主题的教程，快速找到您需要的帮助内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative w-full h-32 md:h-40 rounded-lg overflow-hidden mb-3">
                <img
                  src={categoryImages[cat.slug] || categoryImages['download-tutorial']}
                  alt={cat.name}
                  title={`${cat.name} - 东升大舞台`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm mb-2">
                    <i className={`${cat.icon} text-white text-sm`}></i>
                  </div>
                </div>
              </div>
              <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900 text-center group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h4>
              <p className="text-xs text-foreground-500 text-center mt-1 hidden sm:block">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}